import React from 'react';

import Modelo from '../index';

const ModeloDocumento: React.FC = () => {
  return <Modelo modeloMensagem={false} />;
};

export default ModeloDocumento;
